import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

export interface AccordionItemProps extends HTMLProps<HTMLLIElement> {
  icon?: string | null;
  closeIcon?: string | null;

  title: string;
  subtitle?: string | null;

  open?: boolean;
  select?: boolean;
  setOpen?: (open: boolean) => void;

  buttonClassName?: string;
}

function AccordionItemComponent(
  {
    closeIcon = null,
    icon = null,
    title,
    subtitle,
    select = false,
    buttonClassName = '',
    setOpen,
    children,
    ...props
  }: AccordionItemProps,
  ref: LegacyRef<HTMLLIElement>
) {
  return (
    <li
      ref={ref}
      {...props}
      className={`${props.open ? 'uk-open' : ''} ${props.className || ''}`}
    >
      <button
        className={`uk-accordion-title ${buttonClassName}`}
        onClick={(_) => setOpen}
      >
        <div>
          {icon !== null && <span uk-icon={icon}></span>}
          <div>
            <div>
              <span>{title}</span>
              {subtitle && <div className="uk-navbar-subtitle">{subtitle}</div>}
            </div>
          </div>
        </div>
        {closeIcon && (
          <>
            <span uk-icon={closeIcon}></span>
            <span className="icon-divider">|</span>
          </>
        )}
        <span className="accordion-icon" uk-icon="icon: chevron-right"></span>
      </button>
      <ul className="uk-accordion-content">{children}</ul>
    </li>
  );
}

export default forwardRef(AccordionItemComponent);
